import React, { Component, propTypes } from "react";
import { renderMoney } from "../../utils";
import "./styles.css";
import { WkRadio } from "../wk";
import classnames from "classnames";

const refundTypes = [
  { label: "普通退款", value: 0, key: 0 },
  { label: "全额退款", value: 1, key: 1 },
  { label: "部分退款", value: 2, key: 2 },
  { label: "部分退款（不扣除手续费）", value: 3, key: 3 },
];
class Refund extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  getInitialState() {
    return {
      form: {
        selectedRefundTypeValue: 0,
        customRefund: "",
        reason: "",
      },
      customRefundErrorTips: null,
    };
  }
  get serviceChargeTips() {
    const { nickname } = this.props;
    const type = this.state.form.selectedRefundTypeValue;
    const CNY = this.state.form.customRefund * 100
    const tips = {
      0: `退款将收取【${nickname}】1%的手续费`,
      1: null,
      2: `将扣除1%手续费，学员实际收到退款：${renderMoney(CNY ? (CNY - CNY * 0.01) : 0)}元`,
      3: `不扣除手续费，学员收到退款：${renderMoney(CNY ? CNY : 0)}元`
    };
    return tips[type] || null;
  }
  get isValidated() {
    return this.state.customRefundErrorTips === null;
  }

  changeFormState(k, v) {
    const { onChange } = this.props;
    this.setState((state) => {
      const newState = {
        ...state,
        form: {
          ...state.form,
          [k]: v,
        },
      };
      onChange &&
        onChange({
          ...newState,
          isValidated: this.validate(newState.form.customRefund),
        });
      return newState;
    });
  }
  validate(val) {
    if (val === undefined || val === "" || val <= 0) return false;
    const value = val.toString().match(/^\d*(\.?\d{0,2})/g)[0] || undefined;
    return parseFloat(value) < parseFloat(renderMoney(this.props.amount));
  }

  customRefundChange(val) {
    let value = val.slice(0,8).replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
    if(value && value[value.length-1] !== '.' ){
        value = parseFloat(value).toString()
    }
    const el = document.getElementById('custom-refund-input')
    if(el) {
      el.value = value
    }
    if (!this.validate(value)) {
      this.setState({
        customRefundErrorTips: "退款金额必须低于付款金额且不能为0",
      });
    } else {
      this.setState({ customRefundErrorTips: null });
    }
    this.changeFormState("customRefund", value);
  }

  componentDidMount() {
    this.customRefundChange('selectedRefundTypeValue',this.state.form.selectedRefundTypeValue)
  }

  render() {
    const { form } = this.state;
    const refundTypeValueFlag = form.selectedRefundTypeValue === 2 || form.selectedRefundTypeValue === 3
    return (
      <div className="refund-form">
        <WkRadio
          defaultValue={form.selectedRefundTypeValue}
          options={refundTypes}
          onChange={(value) => {
            this.changeFormState("selectedRefundTypeValue", value);
          }}
        />
        {/* 部分退款 */}
        {refundTypeValueFlag && (
          <div className={classnames("form-item", "custom-refund-form-item")}>
            <label className="label">退款金额</label>
            <input
              value={form.customRefund}
              onChange={(e) => this.customRefundChange(e.target.value)}
              id="custom-refund-input"
              placeholder="请输入要退款的金额"
            />
            <span>元</span>
          </div>
        )}
        {refundTypeValueFlag && this.state.customRefundErrorTips && (
          <div className="custom-refund-error-tips">
            {this.state.customRefundErrorTips}
          </div>
        )}
        {this.serviceChargeTips && (
          <div className="charge-tips">{this.serviceChargeTips}</div>
        )}
        <textarea
          placeholder="请输入退款理由（选填）"
          onChange={(e) => this.changeFormState("reason", e.target.value)}
          value={form.reason}
        ></textarea>
      </div>
    );
  }
}

// Refund.propTypes = {
//   nickname: String,
//   amount: Number,
//   onChange: Function,
// };

export default Refund;



// WEBPACK FOOTER //
// ./src/components/refund/index.js